export const scrollPageFromCookie = () => {

	if ( /scroll/.test( document.cookie ) )
	{
		const splittedCookie = document.cookie.split( `scroll=` )[1];

		if ( splittedCookie )
		{
			const value = splittedCookie.split( `;` )[0];
			
			window.scrollTo( 0, value );
			
			document.cookie = `scroll=0`
		}
	}
}
